
/**
 * 模块名称: 内部结算配置
 * @author zhuyan@372163.com
 */
import React, { useState, useEffect, useMemo, useRef } from 'react'
import api from '@/api'
import HeaderSearch from '@/components/HeaderSearch'
import RangeNumberInput from '@/components/HeaderSearch/RangeNumberInput'
import {
  Table,
  Form,
  Select,
  Spin,
  DatePicker,
  Modal,
  Input,
  message,
  Button,
  InputNumber
} from 'antd'
// import CompanyBackup from '@/components/CompanyBackup'
import CorpFilter from '@/components/CorpFilter'
import Auth from '@/components/AuthMiddleware'
import Import from '@/components/Import'
import Export from '@/components/Export'

const pageIndex = 1
const perPage = 10
let searchParam = {
  page: pageIndex,
  limit: perPage,
  supplierCompanyId: ''
}
const { Option } = Select
const { RangePicker } = DatePicker
const operationArray = [
  { value: '1', label: '为空' },
  { value: '2', label: '非空' },
]
const SettleConfig = (props) => {
  const { match, location, history } = props
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(pageIndex)
  const [limit, setPageSize] = useState(perPage)
  const [total, setTotal] = useState(0)
  const [dataSource, setDataSource] = useState([])
  const [authList, setAuthList] = useState([])
  const [editingSortId, setEditingId] = useState(null)
  const [ratioValue, setRatioValue] = useState('')
  const [isSaving, setIsSaving] = useState(false)
  const [historyVisible, setHistoryVisible] = useState(false)
  const [historyLoading, setHistoryLoading] = useState(false)
  const [historyList, setHistoryList] = useState([])
  const [showImport, setShowImport] = useState(false)
  const [showExport, setShowExport] = useState(false)
  const ImportRef = useRef()
  const productsRef = useRef()
  const [filteredParam, setFilteredParam] = useState({})
  const [accountList, setAccountList] = useState([]) // 公司主体

  useEffect(() => {
    resetParams()
    onSelectAll()
    api.getPageAuth().then(list => setAuthList(list))
    getList()
  }, [])

  const resetParams = () => {
    const { supplierCompanyId } = searchParam
    searchParam = {
      page: pageIndex,
      limit: perPage,
      ...(supplierCompanyId !== undefined && { supplierCompanyId })
    }
    setPageSize(perPage)
  }

  const onSelectAll = () => {
    api.getCorp({ limit: global.paramsLimit }).then(res => {
      setAccountList(res.list || [])
    })
  }

  const getList = values => {
    if (values) {
      const { page, limit, supplierCompanyId } = searchParam
      searchParam = { page, limit, supplierCompanyId, ...values }
    }
    let params = { ...searchParam }
    setLoading(true)
    api.getInternalSettlementList(params).then(data => {
      setPage(searchParam.page)
      setPageSize(searchParam.limit)
      setTotal(data.count)
      setDataSource(data.list)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const onChangeTable = (pagination, filters, sorter) => {
    searchParam.page = pagination.current
    searchParam.limit = pagination.pageSize
    getList()
  }

  const handleTalentClick = (record) => {
    setEditingId(record.id)
    setRatioValue('')
  }

  const handleSaveRatioClick = (record) => {
    if (ratioValue === '' || ratioValue === null) {
      setEditingId(null)
      setRatioValue('')
      setIsSaving(false)
      return
    }
    if (ratioValue === 0 || (ratioValue && (ratioValue < 0.01 || ratioValue > 1.00))) {
      message.error('内部主体结算单价设置范围为0.01~1.00')
      setRatioValue('')
      setIsSaving(false)
      return
    }
    setLoading(true)
    const { supplierCompanyId, projectId, supplierId, companyId } = record
    const params = {
      supplierCompanyId,
      projectId,
      supplierId,
      companyId,
      percent: ratioValue,
      // historyPercent
    }

    api.getInternalSettlementPercent(params).then(data => {
      message.success('保存成功')
      setEditingId(null)
      setRatioValue('')
      setIsSaving(false)
      getList()
    }).catch(() => {
      setIsSaving(false)
      setLoading(false)
    }
    )
  }

  const handleCancelSort = () => {
    if (isSaving) {
      return
    }
    setEditingId(null)
    setRatioValue('')
  }

  // 记录弹窗
  const openHistoryModal = (record) => {
    setHistoryVisible(true)
    setHistoryLoading(true)
    const { companyId, supplierCompanyId, projectId, supplierId } = record
    const params = {
      companyId,
      supplierCompanyId,
      projectId,
      supplierId,
    }
    api.getInternalSettlementHistory(params).then(res => {
      const list = Array.isArray(res) ? res : (res && res.list) || []
      setHistoryList(list)
      setHistoryLoading(false)
    }).catch(() => setHistoryLoading(false))
  }

  const closeHistoryModal = () => {
    setHistoryVisible(false)
    setHistoryList([])
  }

  const cols = [
    {
      title: '序号',
      dataIndex: 'id',
      fixed: 'left',
      align: 'center',
      render: (text, record, index) => total - ((searchParam.page - 1) * searchParam.limit + index)
    },
    {
      title: '项目名称',
      dataIndex: 'projectName',
      fixed: 'left',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '项目ID',
      dataIndex: 'projectId',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '别名',
      dataIndex: 'projectAlias',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '转出公司',
      dataIndex: 'companyName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '供应商',
      dataIndex: 'supplierName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '内部主体结算单价',
      align: 'center',
      dataIndex: 'percent',
      render: (text, record) => {
        const isEditing = editingSortId === record.id
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', minWidth: '80px' }}>
            {isEditing && (
              <InputNumber
                value={ratioValue}
                onChange={(value) => setRatioValue(value)}
                controls={false}
                // onPressEnter={() => handleSaveRatioClick(record)}
                onBlur={handleCancelSort}
                autoFocus
                style={{ width: 80 }}
                placeholder=""
              // precision={2}
              />
            )}
            <span>{text}</span>
          </div>
        )
      }
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '修改人',
      dataIndex: 'operateName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '历史结算单价',
      dataIndex: 'historyPercent',
      align: 'center',
      render: (text) => {
        return text ? (
          <div style={{ whiteSpace: 'pre-line' }}>
            {text}
          </div>
        ) : (
          '-'
        );
      }
    },
    {
      title: '操作',
      dataIndex: 'actions',
      align: 'center',
      fixed: 'right',
      render: (text, record) => {
        const isEditing = editingSortId === record.id
        return (
          <>
            {!isEditing ? (
              <>
                {<a onClick={() => handleTalentClick(record)}>修改</a>}
                {<a style={{ marginLeft: 10 }} onClick={() => openHistoryModal(record)}>记录</a>}
              </>
            ) : (
              <a
                onMouseDown={() => setIsSaving(true)}
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  handleSaveRatioClick(record)
                }}
              >
                保存
              </a>
            )}
          </>
        )
      }
    }
  ]

  const searchItems = useMemo(() => {
    let searchTempArr = [
      {
        label: '项目名称',
        name: 'projectName',
        component: <Input placeholder="请输入项目名称" />,
      },
      {
        label: '项目别名',
        name: 'projectAlias',
        component: <Input placeholder="请输入项目别名" />,
      },
      {
        label: '供应商',
        name: 'supplierName',
        component: <Input placeholder="请输入供应商名称" />,
      },
      {
        label: '结算单价范围',
        name: 'numTogether:percent',
        maxDefaultValue: 1,
        component: <RangeNumberInput placeholderMin="0.00" placeholderMax="1.00" />,
      },
      {
        label: '转出公司',
        name: 'companyId',
        component: (
          <Select
            showSearch={true}
            optionFilterProp="children"
            placeholder="全部"
            allowClear
            dropdownMatchSelectWidth={false}
          >
            <Option value="select-all">全部</Option>
            {
              accountList?.map((v, i) => {
                return <Option value={v.id} key={i}>{v.name}</Option>
              })
            }
          </Select>
        ),
      },
      {
        label: '结算单价',
        name: 'percentStatus',
        component: (
          <Select placeholder="全部"
            allowClear
            showSearch
            optionFilterProp="children"
          >
            <Option value="select-all">全部</Option>
            {
              operationArray?.map((v, i) => {
                return <Option value={v.value} key={v.value}>{v.label}</Option>
              })
            }
          </Select>
        ),
      }
    ]

    return { search: searchTempArr }
  }, [accountList])

  // 点击选择所属公司
  // const onChangeCorp = data => {
  //   if (data && data.id) {
  //     searchParam = {
  //       ...searchParam,
  //       supplierCompanyId: data.id,
  //       page: 1,
  //     }
  //     getList()
  //   } else {
  //     message.error('没有所属公司权限！')
  //   }
  // }

  const onChangeCorp = (data) => {
    searchParam = {
      ...searchParam,
      supplierCompanyId: Array.isArray(data) ? data.map(item => item.id).join(',') : (data && data.id) || '',
      page: 1,
    }
    getList()
  }

  // 导入确定
  const onConfirmImport = (fileList) => {
    if (fileList[0].status !== 'removed') {
      api.getImportPercentImportExcel({
        path: fileList[0].url
      }).then(res => {
        getList()
        message.success('导入成功')
        ImportRef.current.onLoading()
        setShowImport(false)
      }).catch(res => {
        ImportRef.current.onLoading()
      })
    } else {
      message.error('请导入模板')
    }
  }

  const onShowImportDialog = () => {
    ImportRef.current.onRemoved()
    setShowImport(true)
  }

  const onShowExportDialog = () => {
    setShowExport(true)
    const { page, limit, ...filteredSearchParam } = searchParam
    setFilteredParam(filteredSearchParam)
  }


  return (
    <div className="config-settleConfig-container">
      {/* <CompanyBackup onChange={onChangeCorp} radio label="转入公司" /> */}
      <CorpFilter onChange={onChangeCorp} label="转入公司" />
      <Spin spinning={loading} tip="Loading...">
        <div style={{ height: 10 }}></div>
        <HeaderSearch
          {...searchItems}
          getList={getList}
          resetParams={resetParams}
          hasShowAll={false}
        ></HeaderSearch>
        <div className='line'></div>
        <div className="config-settleConfig-btn">
          {/* <Auth auths={authList} code="import">  */}
          <Button type="primary" className='stock-btn-space' onClick={onShowImportDialog}>数据导入</Button>
          {/* </Auth> */}
          {/* <Auth auths={authList} code="export"> */}
          <Button type="primary" className='stock-btn-space' onClick={onShowExportDialog}>数据导出</Button>
          {/* </Auth> */}
        </div>
        <Table
          size="small"
          columns={cols}
          rowKey="id"
          dataSource={dataSource}
          scroll={{ x: 'max-content' }}
          pagination={{
            defaultCurrent: pageIndex,
            pageSize: limit,
            total: total,
            showSizeChanger: true,
            showQuickJumper: true,
            current: page,
            pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
          }}
          onChange={onChangeTable}
        ></Table>
        <Modal
          title="结算单价修改记录"
          visible={historyVisible}
          onCancel={closeHistoryModal}
          footer={[
            <Button key="close" type='primary' onClick={closeHistoryModal}>关闭</Button>
          ]}
          destroyOnClose={true}
          width={800}
        >
          <Table
            size="small"
            rowKey="id"
            dataSource={historyList}
            loading={historyLoading}
            pagination={false}
            columns={[
              {
                title: '序号',
                dataIndex: 'index',
                align: 'center',
                render: (text, record, index) => historyList.length - index
              },
              {
                title: '内部主体结算单价',
                dataIndex: 'percent',
                align: 'center',
                render: (text) => text || '-'
              },
              {
                title: '修改方式',
                dataIndex: 'type',
                align: 'center',
                render: (text) => ({ 1: '页面修改', 2: '数据导入' }[text] || '-')
              },
              {
                title: '更新时间',
                dataIndex: 'updateTime',
                align: 'center',
                render: (text, record) => record.updateTime || record.addTime || '-'
              },
              {
                title: '修改人',
                dataIndex: 'operateName',
                align: 'center',
                render: (text) => text || '-'
              }
            ]}
          />
        </Modal>
      </Spin>
      <Export
        show={showExport}
        onCancel={() => {
          setShowExport(false)
          productsRef.current.changeVal()
        }}
        tplUrl="getInternalSettlementExportTpl"
        fieldsUrl="getInternalSettlementTplItems"
        saveUrl="getInternalSettlementSaveExportTpls"
        exportUrl="getInternalSettlementExport"
        method="export"
        parame={{ ExportType: 'internalsettlement.export', ...filteredParam }}
        cRef={productsRef}
      />
      <Import
        onSearch={onConfirmImport}
        visibleFile={showImport}
        onCloseImport={() => setShowImport(false)}
        ImportTemplate="/api/File/DownTemplate?url=/templates/内部结算价格.xlsx&name=内部结算价格"
        ImportRef={ImportRef}
        title="数据导入"
      />
    </div>
  )
}

export default Form.create()(SettleConfig)
